import { z } from 'zod';
export const nullableOptional = (schema) => z.nullable(z.optional(schema));
//# sourceMappingURL=zod.js.map